<mat-card class="card-style modal-card px-6 py-6 pt-0">
  <mat-card-header class="modal-header flex justify-between items-center">
    <mat-card-title>Itinerários da solicitação</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-6">
    @if (!loading) {
      <div class="flex flex-col gap-4">
        @for (ponto of pontos; track ponto.id) {
          <mat-card
            class="card-style stop-card px-4 pb-6"
            [class.stop-origin]="ponto.trecho == 'O'"
            [class.stop-destination]="ponto.trecho == 'D'"
            [class.stop-waypoint]="ponto.trecho != 'O' && ponto.trecho != 'D'"
          >
            <h4 class="stop-title mb-1">{{ tituloPonto(ponto) }}</h4>

            @if (
              ponto.localParada &&
              ponto.localParada != 'Origem' &&
              ponto.localParada != 'Destino'
            ) {
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-full">
                  <strong>Descrição:</strong> {{ ponto.localParada }}
                </div>
              </div>
            }

            <div class="flex justify-between gap-2 mt-4">
              <div class="w-6/12"><strong>Cidade:</strong> {{ ponto.cidade }}</div>
              <div class="w-6/12"><strong>Estado:</strong> {{ ponto.estado }}</div>
            </div>

            @if (temEndereco(ponto)) {
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-2/12"><strong>Cep:</strong> {{ ponto.cep }}</div>
                <div class="w-8/12">
                  <strong>Logradouro:</strong> {{ ponto.logradouro }}
                </div>
                <div class="w-2/12"><strong>Numero:</strong> {{ ponto.numero }}</div>
              </div>
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-6/12">
                  <strong>Complemento:</strong> {{ ponto.complemento }}
                </div>
                <div class="w-6/12"><strong>Bairro:</strong> {{ ponto.bairro }}</div>
              </div>
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-6/12">
                  <strong>Hora da Parada:</strong> {{ ponto.horaParada }}
                </div>
                <div class="w-6/12">
                  <strong>Tempo de Permanência:</strong> {{ ponto.tempoPermanencia }}
                </div>
              </div>
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-full">
                  <strong>Atividades:</strong> {{ ponto.atividades }}
                </div>
              </div>
            }
          </mat-card>
        } @empty {
          <h3 class="text-center">Sem itinerário cadastrado.</h3>
        }
      </div>
    } @else {
      <div class="mt-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</mat-card>
